import styled from 'styled-components/macro';

// 机器人回复消息内容
export const RobotContent = styled.div`
  background: #FFFFFF;
  border-radius: 10px;
  padding: 15px;
  font-family: Inter-Regular, Inter;
  font-weight: 400;
  color: #000000;
  font-size: 16px;
  line-height: 21px;
  max-width: 65%;
`;
